import {Command} from "./Command";
import {EventManager} from "../event-manager";
import {TCData} from "../model/t-c-data";
import cmpConfig from "../../cmp-config";
import cmp from "../../context/context";

class AddEventListenerCommand extends Command {

    public execute(version: number, callback: Function, parameter?: number[]): void {
        // Suscribimos el listener
        const listenerId:number = EventManager.registerEvent(EventManager.EVENT_CMP_GENERIC, callback);

        // Respondemos inmediatamente con lo que haya en el TCData
        const tcData:TCData = TCData.build(!cmpConfig.gdprApplies ? [] : cmp().vendorList?.vendorIds()??[]);
        tcData.listenerId = listenerId;
        callback(tcData, true);
    }

}

export {AddEventListenerCommand}
